<script>
  import { _ } from 'svelte-i18n'
  import { modals, font_id_to_tag, flash_content, user_font_tags, detected_fonts, user } from '../../stores'
  import { saveTag, reloadTagedFonts } from '../../services/tags'
  import { flatMap, find, filter, uniq } from 'lodash'
  import Fieldset from '../../elements/Fieldset.svelte'
  import Button from '../../elements/Button.svelte'
  import FormError from '../../elements/FormError.svelte'
  import Modal from '../../elements/Modal.svelte'
  import ButtonGroup from '../../elements/ButtonGroup.svelte'
  import SelectList from '../../elements/SelectList.svelte'
  import Tabs from '../../elements/Tabs.svelte'

  let modal_id = 'saveTag'
  let button_busy = false
  let form_element
  let show_save_error = false
  let tag_name = ''
  let list_items
  const tab_options = [
    {value:'tagging_single', display:'Tag single font'}, 
    {value:'tagging_selected', display:'Tag selected fonts'}
  ]
  let selected_tab = 'tagging_single'
  
  $: $user_font_tags, setListItems()

  $: singleAndMultipleSelection = () => {
    let selected_count = filter($detected_fonts, 'selected').length
    if ($font_id_to_tag === undefined) return false
    if (selected_count === 0) return false
    if (selected_count > 1) return true

    if ( selected_count === 1) {
      let selected_font_id = filter($detected_fonts, 'selected')[0].id
      return selected_font_id === $font_id_to_tag ? false : true
    }
    return false
  }

  function setListItems() {
    list_items = flatMap($user_font_tags, (f, i) => f.tag_name)
  }

  async function handleSubmit(event) {
    // prepare fontnames string to save
    
    // is existing tag selected?
    let existing_tag = find($user_font_tags, (f) => f.tag_name.toLowerCase() === tag_name.toLowerCase() )
    let tag_id = existing_tag ? existing_tag.id : undefined
    tag_name = existing_tag ? existing_tag.tag_name : tag_name
    
    // get fonts tagged with existing tag
    let already_tagged_fonts_string = existing_tag ? existing_tag.fonts : undefined
    let already_tagged_fonts = already_tagged_fonts_string ? already_tagged_fonts_string.split('|-|') : undefined
    
    // get postscriptName array of selected fonts or the font that solely initated the modal
    let fonts_to_tag
    if (($font_id_to_tag !== undefined) && selected_tab === 'tagging_single') {
      fonts_to_tag = [find($detected_fonts, (f) => f.id === $font_id_to_tag ).postscript_name]
      console.log("taging single font: " + JSON.stringify(fonts_to_tag))
    } else {
      fonts_to_tag = flatMap(filter($detected_fonts, 'selected'), f => f.postscript_name)
      console.log("taging multiple fonts: " + JSON.stringify(fonts_to_tag))
    }
    let fonts_to_save
    if (already_tagged_fonts) {
      fonts_to_save = uniq([...already_tagged_fonts, ...fonts_to_tag]).sort().join('|-|')
    } else {
      fonts_to_save = fonts_to_tag.join('|-|')
    }

    // guard
    if (fonts_to_save.length === 0 || tag_name.length === 0) {console.error('no fonts selected or no tagname entered to save'); return}

    button_busy = true
    show_save_error = false

    let form_data = new FormData()
    if (tag_id) form_data.append('tag_id', tag_id)
    form_data.append('tag_name', tag_name)
    form_data.append('fonts', fonts_to_save)
    form_data.append('user_id', $user.id)

    try {
      const response = await saveTag(form_data)
      button_busy = false

      if (response.data === false) show_save_error = true
      else { 
        reloadTagedFonts()
        modals.close()
        if (fonts_to_tag.length === 1) {
          $flash_content = {
            message: $_('flashes.userSavedSingleFontTag', {values: {font_name: fonts_to_tag[0], tag_name: tag_name} }),
            bright: true
          }
        }else {
          $flash_content = {
            message: $_('flashes.userSavedTag', {values: {selection_count: fonts_to_tag.length, tag_name: tag_name} }),
            bright: true
          }
        }
        tag_name = ''
      }
    } catch (error) {
      button_busy = false
      console.log("Error with save tag request")
    }
    resetModalVars()
  }

  function resetModalVars() {
    $font_id_to_tag = undefined
    selected_tab = 'tagging_single'
  }

</script>

<Modal id={modal_id} on:modalClosed={resetModalVars} flush_header={singleAndMultipleSelection()}>
  <span slot="header">
    {#if ($font_id_to_tag !== undefined) && selected_tab === "tagging_single"}
      {@html $_('modals.saveTag.titleAlt', { values: { font_name: find($detected_fonts, (f) => f.id === $font_id_to_tag)?.display_name } })}
    {:else}
      {@html $_('modals.saveTag.title')}
    {/if}
  </span>
  <span slot="content">
    {#if singleAndMultipleSelection()}
      <Tabs tab_options={tab_options} flush={true} bind:selected_tab={selected_tab} />
    {/if}
    <FormError bind:visible={show_save_error}>{@html $_('modals.saveTag.saveError')}</FormError>
    <form bind:this={form_element} on:submit|preventDefault="{handleSubmit}">
      <div class="intro">
        {$_('modals.saveTag.intro')}
      </div>
      <Fieldset>
        <SelectList {list_items} label={$_('modals.saveTag.label')} bind:entered_name={tag_name}/>
      </Fieldset>
      <ButtonGroup mt={3}>
        <Button kind="accent" type="submit" busy={button_busy}>{$_('buttons.save')}</Button>
        <Button kind="outline" on:click={() => {resetModalVars(); modals.close()}}>{$_('buttons.cancel')}</Button>
      </ButtonGroup>
    </form>
  </span>
</Modal>

<style>
  .intro {
    margin-bottom: 2rem;
  }
</style>